module.exports = __webpack_public_path__ + "static/media/gridTwo.feb4252d.png";